import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { TaskTable } from "@/features/work/components/task-table"
import { taskQueries } from "@/queries/tasks"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/tasks/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(taskQueries.mine()),
  component: TasksPage,
})

function TasksPage() {
  return (
    <>
      <PageHeader title="Tasks" />
      <TaskTable />
    </>
  )
}
